import React from 'react'
import { Tab as MuiTab, withStyles } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS } from '../colors.constant'

const Tab = withStyles(theme => ({
  root: {
    fontSize: 14,
    padding: '0 4px',
    minHeight: 32,
    minWidth: 20,
    opacity: 1,
    color: GRAY_COLORS[500]
  },
  selected: {
    color: PRIMARY_COLORS[700]
  }
}))(props => <MuiTab disableRipple {...props} />)
export default Tab
